import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import usePrevious from 'hooks/usePrevious';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { addRemoveRequest, deleteRemoveRequest } from 'utility/general';

const SLayout = styled.div``;

const ClusterSelection = ({
    value = '',
    onChange = (e) => null,
    style = {},
    name = 'cluster',
    allowClusters = [],
    allowAction = true,
    isRequired = false,
    disableOtherOption = false,
    disableOnPermission = false,
    disabled,
    deleteRequestKey,
    isValidValue = (isValid) => null,
    forceErrorDisplay = false,
    onAppFieldValidate,
    updateApplicationFormOnDisableChange = -1,
    updateSiteFormOnDisableChange = -1,
}) => {
    const hospitals = useSelector((state) => state.system.hospitals);

    const previousDisable = usePrevious(`${allowAction}`);

    useEffect(() => {
        // updateApplicationFormOnDisableChange = application id
        if (previousDisable && (updateApplicationFormOnDisableChange >= 0 || updateSiteFormOnDisableChange >= 0)) {
            if (!name) {
                throw new Error('name is required');
            }

            const isDisabled = getDisableStatus();
            if (isDisabled) {
                addRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    name: deleteRequestKey ?? name,
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            } else {
                deleteRemoveRequest({
                    applicationFormId: updateApplicationFormOnDisableChange,
                    keys: [deleteRequestKey ?? name],
                    siteInfoId: updateSiteFormOnDisableChange,
                });
            }
        }

        checkAppFieldValidate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowAction, disabled]);

    useEffect(() => {
        checkAppFieldValidate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const checkAppFieldValidate = () => {
        if (onAppFieldValidate !== undefined) {
            if (!name) {
                throw new Error('name is required');
            }

            const isDisabled = getDisableStatus();

            if (isDisabled) {
                onAppFieldValidate(name, true);
            } else {
                if (value) {
                    onAppFieldValidate(name, true);
                } else {
                    onAppFieldValidate(name, false);
                }
            }
        }
    };

    const getDisableStatus = () => {
        if (disableOnPermission) {
            return true;
        }

        if (disabled) {
            return true;
        }

        if (allowAction === false) {
            return true;
        }

        return false;
    };

    const formattedList = hospitals.map((item) => {
        return {
            key: item.clusterName,
            display: item.clusterName,
            isDisabled: false,
        };
    });

    const getFilteredList = () => {
        if (allowClusters.length > 0) {
            return formattedList.filter((item) => {
                return allowClusters.includes(item.key);
            });
        }

        if (disableOtherOption) {
            return formattedList.filter((item) => item.key !== 'OTHERS');
        }

        return [
            {
                key: 'undefined',
                display: 'Please Choose One',
                isDisabled: true,
            },
            ...formattedList,
        ];
    };

    const onDataChange = (e) => {
        const { name, value } = e.target;
        // const clusterName = getClusterDisplayFromId(value);
        onChange({
            target: {
                name,
                value: value,
            },
        });
    };

    return (
        <SLayout style={style}>
            <CustomOutlineSelect
                forceErrorDisplay={forceErrorDisplay}
                value={value}
                label="Cluster"
                showEmptyChoice={false}
                disabled={getDisableStatus()}
                choices={getFilteredList()}
                onChange={onDataChange}
                name={name}
                isRequired={isRequired}
                isValidValue={isValidValue}
            />
        </SLayout>
    );
};

export default ClusterSelection;
